import {ReloadButton,} from '@flexinet/ui-components';

import {Box,} from '@mantine/core';
import {useAliases} from "../hooks/useAliases.ts";

export const ReloadRecordsButton = () => {

    const {refetchRecords} = useAliases();
    return (
        <Box mx='s'>
            <ReloadButton onClick={() => refetchRecords()}/>
        </Box>
    );
};
